import React, { useState } from "react";

import { DynamicContent } from "@/components/DynamicContent";
import { useFela } from "react-fela";
import { LinkButton } from "@/components/LinkButton";
import { useTheme } from "@/hooks/useTheme";
import { ConverterFeaturesTab } from "./ConverterFeaturesTabs";
import { ConverterFeaturesLegend } from "./ConverterFeaturesLegend";
import { conversionTargetsData, converterFeaturesLegend, data } from "./data";
import { ILegendData, ILegendItem, IConverterFeaturesTableData } from "./types";
import { IConversionTarget } from "../Converter/types";
import { ConverterFeaturesTable } from "./ConverterFeaturesTable";

export const ConverterFeatures: React.FC = () => {
  const { css } = useFela();
  const { bp } = useTheme();

  const [activeTab, setActiveTab] = useState<IConversionTarget>("xd");

  const tabs: IConversionTarget[] = Object.keys(data) as IConversionTarget[];

  return (
    <DynamicContent>
      <div
        className={css({
          maxWidth: 900,
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-betweeen",
          marginBottom: 20,
          [bp.FROM_TABLET]: {
            borderBottom: `1px solid #E5E7EB`,
            flexDirection: "row",
            justifyContent: "center",
            margin: "0px auto 54px",
          },
        })}
      >
        {tabs.map((tab: IConversionTarget, i: number) => {
          return (
            <ConverterFeaturesTab
              key={i}
              tab={
                conversionTargetsData[
                  tab as keyof IConverterFeaturesTableData
                ] as ILegendItem
              }
              isActive={activeTab === tab}
              handleClick={() => setActiveTab(tab)}
            />
          );
        })}
      </div>
      <ConverterFeaturesLegend
        legend={Object.values(converterFeaturesLegend)}
      />
      <ConverterFeaturesTable
        data={data[activeTab as keyof IConverterFeaturesTableData]}
        legend={converterFeaturesLegend as ILegendData}
      />
      <LinkButton
        title="Get started"
        href="/"
        customStyle={{ width: "max-content", margin: "58px auto 0" }}
      />
    </DynamicContent>
  );
};
